export const getStations = (bounds, filter) => ({
    type: 'GET_STATIONS',
    payload: {
        bounds: bounds,
        filter: filter
    }
});

export const setGeoPosition = (position) => ({
    type: 'SET_GEO_POSITION',
    payload: {
        position: position
    }
});

export const getStation = (uuid) => ({
    type: 'GET_STATION',
    payload: {
        uuid: uuid
    }
});

export const resetStation = () => ({
    type: 'RESET_STATION'
});

export const resetFilter = () => ({
    type: 'RESET_FILTER'
});

// export const setFilterData = (filter) => ({
//     type: 'SET_FILTER_DATA',
//     payload: {
//         filter: filter
//     }
// });

export const saveFilterData = (filter) => ({
    type: 'SAVE_FILTER_DATA',
    payload: {
        filter: filter
    }
});

export const getFilterData = () => ({
    type: 'SET_FILTER_DATA'
});

export const getPlannedStations = (bounds, filter) => ({
    type: 'GET_PLANNED_STATIONS',
    payload: {
        bounds: bounds,
        filter: filter
    }
});